const CallForPricing = () => (
  <span className="text-gray-600">Call for pricing</span>
);

export default CallForPricing;
